/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9eddebd4 (Tue Feb 17 18:34:36 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  UpdateRegionContentTagsRequestBodyContentTags,
  UpdateRegionContentTagsRequestBodyContentTagsFromJSON,
  UpdateRegionContentTagsRequestBodyContentTagsToJSON,
} from './'

/**
 *
 * @export
 * @interface UpdateRegionContentTagsRequestBody
 */
export interface UpdateRegionContentTagsRequestBody {
  /**
   * content tags for the specified region.
   * @type {Array<UpdateRegionContentTagsRequestBodyContentTags>}
   * @memberof UpdateRegionContentTagsRequestBody
   */
  contentTags: Array<UpdateRegionContentTagsRequestBodyContentTags>
}

export function UpdateRegionContentTagsRequestBodyFromJSON(
  json: any
): UpdateRegionContentTagsRequestBody {
  return UpdateRegionContentTagsRequestBodyFromJSONTyped(json, false)
}

export function UpdateRegionContentTagsRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateRegionContentTagsRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contentTags: (json['contentTags'] as Array<any>).map(
      UpdateRegionContentTagsRequestBodyContentTagsFromJSON
    ),
  }
}

export function UpdateRegionContentTagsRequestBodyToJSON(
  value?: UpdateRegionContentTagsRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contentTags: (value.contentTags as Array<any>).map(
      UpdateRegionContentTagsRequestBodyContentTagsToJSON
    ),
  }
}
